import { useTranslate } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { formatDuration, type LeadKpis } from "./leadUtils";

const Tile = ({
  label,
  value,
  hint,
}: {
  label: string;
  value: string;
  hint?: string;
}) => {
  const translate = useTranslate();
  return (
    <Card>
      <CardContent className="p-4 flex flex-col gap-1">
        <span className="text-xs text-muted-foreground">
          {translate(label)}
        </span>
        <span className="text-2xl font-semibold tabular-nums">{value}</span>
        {hint ? (
          <span className="text-xs text-muted-foreground">{hint}</span>
        ) : null}
      </CardContent>
    </Card>
  );
};

export const LeadKpiTiles = ({ kpis }: { kpis: LeadKpis }) => {
  const translate = useTranslate();
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
      <Tile
        label="crm.kpi.total"
        value={String(kpis.total)}
        hint={translate("crm.kpi.open_hint", { count: kpis.open })}
      />
      <Tile
        label="crm.kpi.response_median"
        value={formatDuration(kpis.responseMedian)}
        hint={translate("crm.kpi.within_target", {
          percent: kpis.responseWithinTarget,
        })}
      />
      <Tile
        label="crm.kpi.claim_median"
        value={formatDuration(kpis.claimMedian)}
      />
      <Tile
        label="crm.kpi.reached_rate"
        value={`${kpis.reachedRate} %`}
        hint={translate("crm.kpi.count_hint", { count: kpis.reached })}
      />
      <Tile
        label="crm.kpi.appointment_rate"
        value={`${kpis.appointmentRate} %`}
        hint={translate("crm.kpi.count_hint", { count: kpis.appointments })}
      />
      <Tile
        label="crm.kpi.close_rate"
        value={`${kpis.closeRate} %`}
        hint={translate("crm.kpi.count_hint", { count: kpis.closed })}
      />
    </div>
  );
};
